import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (!measurementId || measurementId === 'YOUR_GA4_MEASUREMENT_ID') {
    console.warn('Google Analytics measurement ID not configured');
    return;
  }

  // Load gtag script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  
  gtag('js', new Date());
  gtag('config', measurementId, {
    send_page_view: true,
    cookie_flags: 'SameSite=None;Secure'
  });

  console.log('Google Analytics initialized:', measurementId);
};

// Track page views
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }, [location]);
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
    console.log('GA Event:', eventName, eventParams);
  }
};

// Conversion Events
export const trackSignup = (subscriptionTier = 'free') => {
  trackEvent('sign_up', {
    method: 'email',
    subscription_tier: subscriptionTier
  });
};

export const trackUpgrade = (fromTier = 'free', toTier = 'premium') => {
  trackEvent('purchase', {
    value: 15.00,
    currency: 'USD',
    transaction_id: `upgrade_${Date.now()}`,
    items: [{
      item_id: 'premium_monthly',
      item_name: 'Premium Monthly Subscription',
      price: 15.00,
      quantity: 1
    }]
  });
  
  trackEvent('conversion', {
    from_tier: fromTier,
    to_tier: toTier
  });
};

export const trackPersonaClick = (personaName) => {
  trackEvent('persona_click', {
    persona_name: personaName,
    event_category: 'engagement',
    event_label: `Clicked ${personaName}`
  });
};

export const trackFeatureGateView = (featureName) => {
  trackEvent('feature_gate_view', {
    feature_name: featureName,
    event_category: 'conversion_funnel'
  });
};

export const trackUpgradeButtonClick = (location) => {
  trackEvent('upgrade_button_click', {
    button_location: location,
    event_category: 'conversion_funnel'
  });
};

export const trackMessageLimit = (messagesUsed, messagesLimit) => {
  trackEvent('message_limit_reached', {
    messages_used: messagesUsed,
    messages_limit: messagesLimit,
    event_category: 'engagement'
  });
};

export const trackForumAccess = (hasAccess) => {
  trackEvent('forum_access', {
    has_access: hasAccess,
    event_category: 'engagement'
  });
};

export const trackCourseAccess = (hasAccess) => {
  trackEvent('course_access', {
    has_access: hasAccess,
    event_category: 'engagement'
  });
};

// Track outbound links
export const trackOutboundLink = (url, label) => {
  trackEvent('click', {
    event_category: 'outbound',
    event_label: label,
    transport_type: 'beacon',
    event_callback: () => {
      document.location = url;
    }
  });
};
